// File: src/theme.js

// 1) Color Palette — unify all major colors, including brand, neutrals, statuses.
const COLORS = {
    // Brand
    primary: '#007bff',
    primaryHover: '#106ad7',
  
    // Semantic statuses
    danger: '#ff4d4f',
    success: '#28a745',
    warning: '#faad14',
  
    // Neutral grays
    textMain: '#333333',
    textSub: '#666666',
    textPlaceholder: '#999999',
    border: '#dddddd', // or '#ccc'
    borderLight: '#eeeeee',
    background: '#ffffff',
    backgroundAlt: '#f0f0f0',
    highlight: '#f5f5f5',
  
    // Others from your code
    // (For example if you need #1890ff or #2C9CFD consistently)
    accentBlue: '#1890ff',
    chatBubbleBlue: '#2C9CFD',
  };
  
  // 2) Spacing Scale — standardize margin/padding/gaps to keep consistency.
  const SPACING = {
    xs: 4,    // e.g.  4px
    sm: 8,    // e.g.  8px
    md: 16,   // e.g. 16px
    lg: 24,   // e.g. 24px
    xl: 32,   // e.g. 32px
    xxl: 48,  // e.g. 48px
  };
  
  // 3) Typography — define font families, sizes, weights, line-heights.
  const TYPOGRAPHY = {
    fontFamilyBase: "'Open Sans', sans-serif",
  
    // Font sizes (could also be in px or rem)
    fontSizeSm: '12px',
    fontSizeMd: '14px',
    fontSizeLg: '16px',
    fontSizeXl: '20px',
    fontSizeXxl: '24px',
    fontSizeHero: '28px',
  
    // Weights
    fontWeightNormal: 400,
    fontWeightMedium: 500,
    fontWeightBold: 600,
    fontWeightExtraBold: 700,
  };
  
  // 4) Border Radius — unify radii for buttons, cards, modals, etc.
  const BORDER_RADIUS = {
    sm: '4px',
    md: '6px',
    lg: '8px',
    xl: '12px',
  };
  
  // 5) Shadows — unify common box shadows for cards, modals, popovers, etc.
  const SHADOWS = {
    card: '0 2px 6px rgba(0, 0, 0, 0.15)', // example
    dropdown: '0 2px 8px rgba(0, 0, 0, 0.12)',
    buttonFocus: '0 0 0 3px rgba(0, 123, 255, 0.3)',
  };
  
  // 6) Transitions — unify transition durations & easing for hovers, modals, etc.
  const TRANSITIONS = {
    default: 'all 0.2s ease',
    fast: 'all 0.1s ease',
    slow: 'all 0.4s ease',
  };
  
  // 7) Z-Indices — useful if you want layers for dropdowns, modals, tooltips, etc.
  const Z_INDEX = {
    dropdown: 1000,
    modal: 1300,
    popover: 1500,
    tooltip: 2000,
  };
  
  // 8) Finally, export a single theme object that aggregates everything.
  const theme = {
    colors: COLORS,
    spacing: SPACING,
    typography: TYPOGRAPHY,
    borderRadius: BORDER_RADIUS,
    shadows: SHADOWS,
    transitions: TRANSITIONS,
    zIndex: Z_INDEX,
  };
  
  export default theme;
  